function superSwitch ( link, elementID, text ) {
  if ( link.innerHTML != text )
  {
	link.oldInnerHTML = link.innerHTML;
	link.innerHTML = text;
	new Effect.SlideDown( elementID );  
  } 
  else
  {
	link.innerHTML = link.oldInnerHTML;
	new Effect.SlideUp( elementID );
  }
}